import { ElementRef, EventEmitter, QueryList } from '@angular/core';
import { SatPopover } from '@ncstate/sat-popover';
import { SearchQuery } from '../models/search-query.model';
import { State } from '../../shared/state-view/state.model';
import { ACTIVITY_FILTERS } from '../filters/activity-filters';
var ActivityResultsListingComponent = /** @class */ (function () {
    function ActivityResultsListingComponent() {
        this.activities = [];
        this.state = State.Empty;
        this.selectedActivityChange = new EventEmitter();
        this.activityMouseEnter = new EventEmitter();
        this.activityMouseLeave = new EventEmitter();
    }
    Object.defineProperty(ActivityResultsListingComponent.prototype, "activityLabel", {
        get: function () {
            if (!this.query.activity) {
                return '';
            }
            var f = ACTIVITY_FILTERS.get(this.query.activity);
            return f ? f.label : '';
        },
        enumerable: true,
        configurable: true
    });
    ActivityResultsListingComponent.prototype.onActivityHover = function (activity, hover) {
        if (hover) {
            this.activityMouseEnter.emit(activity);
        }
        else {
            this.activityMouseLeave.emit(activity);
        }
    };
    /**
     * Returns a jQuery element container for the given activity.
     */
    ActivityResultsListingComponent.prototype.getActivityEl = function (activity) {
        var i = this.activities.indexOf(activity);
        if (i < 0) {
            return null;
        }
        var el = this.activityEls.toArray()[i];
        return $(el.nativeElement);
    };
    /**
     * Scrolls the activities list to the specified activity, marking it as selected.
     */
    ActivityResultsListingComponent.prototype.scrollToActivity = function (activity) {
        if (!this.listEl) {
            return;
        }
        var $containerEl = $(this.listEl.nativeElement);
        var $el = this.getActivityEl(activity);
        if (!$el) {
            return;
        }
        var position = $el[0].offsetTop;
        $containerEl.stop(true);
        $containerEl.animate({ scrollTop: position }, 500);
    };
    ActivityResultsListingComponent.prototype.onSelectedActivityChange = function (activityType) {
        this.selectedActivityChange.emit(activityType);
    };
    return ActivityResultsListingComponent;
}());
export { ActivityResultsListingComponent };
